import {
  Avatar,
  Container,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import image from "../assets/image.png";
import { getUserInfo } from "../store/rootReducer";
const ProfilePage = () => {
  const [editable, setEditable] = useState(false);
  const userInfo = useSelector(getUserInfo);
  console.log("--", userInfo);

  return (
    <Container sx={{ marginTop: 4 }}>
      <Paper sx={{ padding: 3 }}>
        <Grid container spacing={2} direction="column" alignItems="center">
          <Grid item>
            <Avatar sx={{ width: 120, height: 120 }} src={image} />
          </Grid>
          <Grid item>
            <Typography variant="h4">{userInfo.name}</Typography>
          </Grid>
        </Grid>
        <Divider sx={{ marginY: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Information</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={userInfo.name}
             // disabled={!editable}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={userInfo.email}
              //disabled={!editable}
            />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ProfilePage;
